import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative inline-block border border-neutral-400 hover:bg-gray-100 rounded-full" }
const _hoisted_2 = { class: "text-sm text-neutral-400" }
const _hoisted_3 = { class: "max-h-[285px] w-[160px]" }
const _hoisted_4 = { class: "flex gap-1 justify-center items-center text-[16px] font-normal p-[16px]" }
const _hoisted_5 = { class: "relative flex justify-center w-full text-[14px] font-normal pb-[16px] max-h-[190px] scrolbar-filter ds-scrollbar overflow-y-scroll" }
const _hoisted_6 = { class: "h-full flex flex-col items-center max-h-[190px] mr-[19px]" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "h-full flex flex-col items-center max-h-[190px]" }
const _hoisted_9 = ["onClick"]

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeFilter',
  props: {
    isOpen: { type: Boolean },
    label: {},
    icon: {},
    options: {},
    initialStartValue: { default: '' },
    initialEndValue: { default: '' },
    applyButtonText: { default: 'Aplicar' }
  },
  emits: ["apply", "toggle"],
  setup(__props: any, { emit }) {

const props = __props;




const startValue = ref(props.initialStartValue || props.options[0])
const endValue = ref(props.initialEndValue || props.options[0])

function selectValue(type: 'start' | 'end', value: string) {
  if (type === 'start') {
    startValue.value = value
  } else {
    endValue.value = value
  }
}

function handleApply() {
  emit('apply', { start: startValue.value, end: endValue.value })
}

watch(
  () => [props.initialStartValue, props.initialEndValue],
  ([newStart, newEnd]) => {
    startValue.value = newStart || props.options[0]
    endValue.value = newEnd || props.options[0]
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle'))),
      class: "filter-btn"
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1)
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
          class: "absolute z-10 mt-2 rounded-md shadow-lg bg-white border border-gray-200"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "py-[4px] px-[5px] w-[55px] focus:bg-[#F0F0F4] focus-visible:outline-0 focus:rounded-t focus:border-t-0 focus:border-r-0 focus:border-l-0 focus:border-b-2 focus:border-[#2f7f91]",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startValue).value = $event))
              }, null, 512), [
                [_vModelText, startValue.value]
              ]),
              _createTextVNode(" - "),
              _withDirectives(_createElementVNode("input", {
                class: "py-[4px] px-[5px] w-[55px] focus:bg-[#F0F0F4] focus-visible:outline-0 focus:rounded-t focus:border-t-0 focus:border-r-0 focus:border-l-0 focus:border-b-2 focus:border-[#2f7f91]",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endValue).value = $event))
              }, null, 512), [
                [_vModelText, endValue.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `start-${option}`,
                    class: "cursor-pointer p-[6px] hover:bg-gray-200 rounded",
                    onClick: ($event: any) => (selectValue('start', option))
                  }, _toDisplayString(option), 9, _hoisted_7))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `end-${option}`,
                    class: "cursor-pointer p-[6px] hover:bg-gray-200 rounded",
                    onClick: ($event: any) => (selectValue('end', option))
                  }, _toDisplayString(option), 9, _hoisted_9))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              onClick: handleApply,
              class: "mt-1 cursor-pointer border-t text-center w-full text-xs font-semibold py-1 h-[25px] hover:bg-gray-100 rounded-b-md"
            }, _toDisplayString(_ctx.applyButtonText), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})